import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M0.616900044,9.50902682 C0.541625279,9.33105729 0.5,9.13538986 0.5,8.93000031 C0.5,8.51922125 0.666501117,8.1473306 0.935697001,7.87813472 L7.94813441,0.86569731 C8.52906374,0.284767976 9.4709363,0.284767976 10.0518656,0.86569731 C10.6327949,1.44662665 10.6327949,2.38849919 10.0518656,2.96942853 L5.57885644,7.44243771 L19.838314,7.44243771 C20.6598721,7.44243771 21.3258766,8.10844218 21.3258766,8.93000031 C21.3258766,9.75155847 20.6598721,10.4175629 19.838314,10.4175629 L5.57885644,10.4175629 L10.0518656,14.8905722 C10.6327949,15.4715015 10.6327949,16.413374 10.0518656,16.9943033 C9.4709363,17.5752326 8.52906374,17.5752326 7.94813441,16.9943033 L0.935697001,9.98186593 C0.790464668,9.8366336 0.681540418,9.66884232 0.60892425,9.48977155 L0.616900044,9.50902682 Z"
      transform="matrix(-1 0 0 1 20 3)"
      fill={fill}
    />
  </g>
);

export default Icon;
